import { Link } from 'react-router-dom';

// material-ui
import { Typography, ButtonBase, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project imports
import config from 'config';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <ButtonBase disableRipple component={Link} to={config.defaultPath}>
            <Typography color={theme.palette.secondary.main} gutterBottom variant={matchDownSM ? 'h3' : 'h2'}>
                BAYSTEN
            </Typography>
        </ButtonBase>
    );
};

export default LogoSection;
